import AdAccountModel from '../model/AdAccountModel';

export type AdAccountsState = {
  busy: boolean;
  entities: AdAccountModel[];
  next: string;
};

export enum CallToAction {
  SEND_MESSAGE = 'send_message',
  DONATE_NOW = 'donate_now',
  GET_QUOTE = 'get_quote',
  LEARN_MORE = 'learn_more',
  SIGN_UP = 'sign_up',
  SUBSCRPIBE = 'subscribe',
  SHOP_NOW = 'shop_now',
  APPLY_NOW = 'apply_now',
  CONTACT_US = 'contact_us',
  BOOK_NOW = 'book_travel',
}

export enum SpecialAdCategory {
  HOUSING = 'housing',
  EMPLOYMENT = 'employment',
  CREDIT = 'credit',
}

export enum CampaignBudgetType {
  DAILY = 'daily_campaign',
  LIFETIME = 'lifetime_campaign',
}

export enum AdSetBudgetType {
  DAILY = 'daily_ad_set',
  LIFETIME = 'lifetime_ad_set',
}
